import { checkResponse } from "src/components/js/statics1";
import { newStepLogMessage } from "./stepLog/stepLogMessageClass";
import { keikka_varmenne_save_to_db } from "./keikka/KeikkaFunctions";
import { cache_read, cache_write, general_cacheName } from "src/components/js/CacheFunctions";
import { socketOnSave } from "./system/socketClass";

export default class tilaClass {
  constructor() {
    this.keikkaId = 0;
    this.keikkaTilaId = 0;
    this.keikkaTilaSelite = "";
    this.keikkaTilaCategory = "Muut";
    this.muokkausTila = false;
    this.isStepLogAccepted = false;
    this.isLaskutusSet = false;
    this.isToimitusSet = false;
    this.keikkaTilaSelite2 = "";
    this.keikkaTilaSelite3 = "";
    this.iconName = "";
    this.iconColor = "";
    this.mainAction = "";
    this.mainAdminAction = "";
  }
  get isMuokkausTila() {
    return this.muokkausTila;
  }
  get isPeruttu() {
    return this.iconName === "peruttu";
  }
  get isLuonnos() {
    return this.iconName === "luonnos";
  }
  get isLahetetty() {
    return this.iconName === "lähetetty";
  }
  get isKasiteltavana() {
    return this.iconName === "käsittelyssä";
  }
  get isMeneillään() {
    return this.iconName === "meneillään";
  }
  get isValmis() {
    return this.iconName === "valmis";
  }
  get isEpäonnistunut() {
    return this.iconName === "epäonnistui";
  }
  get isPoistettu() {
    return this.iconName === "poistettu";
  }
  get isToimitusvalmis() {
    return this.iconName === "toimitusvalmis";
  }
  get isToimitettu() {
    return (
      this.iconName === "toimitettu1" ||
      this.iconName === "toimitettu2" ||
      this.iconName === "toimitettu3"
    );
  }
  get isToimitusMeneillään() {
    return this.iconName === "meneillään";
  }
  get isToimitusAloitettu() {
    if (this.isToimitettu || this.isToimitusMeneillään) return true;
    if (this.muokkausTila && [9, 5].includes(this.origKeikkaTilaId)) return true;
    return false;
  }
  get isOtherTila() {
    return (
      !this.isLuonnos &&
      !this.isLahetetty &&
      !this.isKasiteltavana &&
      !this.isToimitusvalmis &&
      !this.isToimitettu
    );
  }
  reloadTilaDataFromAPI = async () => {
    try {
      const url1 = import.meta.env.VITE_SERVER_URL + "/api/tila/get/" + this.keikkaTilaId;
      const c = cache_read(general_cacheName, url1);
      if (c) {
        this.setTilaDataFromJson(c);
        return;
      }
      const response = await fetch(url1, {
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": 3600,
        },
      });
      const cResponse = await checkResponse(response, "tilaClass:reloadTilaDataFromAPI");
      if (!cResponse.success) return false;
      const result = cResponse.data;
      cache_write(general_cacheName, url1, result[0], 0);
      this.setTilaDataFromJson(result[0]);
    } catch (err) {
      console.log(err);
    }
  };
  setTilaDataFromJson = (data) => {
    this.keikkaTilaId = data.keikkaTilaId;
    this.keikkaTilaSelite = data.keikkaTilaSelite;
    this.keikkaTilaSelite2 = data.keikkaTilaSelite2;
    this.keikkaTilaSelite3 = data.keikkaTilaSelite3;
    this.iconName = data.iconName;
    this.iconColor = data.iconColor;
    this.mainAction = data.mainAction;
    this.mainAdminAction = data.mainAdminAction;
    this.keikkaTilaCategory = data.keikkaTilaCategory;
  };
  // reload to get current successTilaId, keikkaTilaSelite yms.
  saveKeikkaTilaToDB = async (personId, token, reload, socket, varmenne = undefined) => {
    await keikkaTila_saveToDB(this.keikkaId, this.keikkaTilaId, personId, token, socket);
    if (varmenne != undefined) keikka_varmenne_save_to_db(this.keikkaId, varmenne, token);
    reload && (await this.reloadTilaDataFromAPI());
  };

  get tilaHash() {
    return (
      (this.keikkaTilaId || 0) +
      (this.acceptAikaTime == null ? 43 : 5) +
      (this.acceptPumppuTime == null ? 7 : 11) +
      (this.acceptM3Time == null ? 13 : 17) +
      (this.acceptBetoniTime == null ? 19 : 23) +
      (this.acceptOsoiteTime == null ? 29 : 31) +
      (this.acceptAsiakasTime == null ? 37 : 41) +
      (this.muokkausTila ? 3 : 59) +
      (this.isStepLogAccepted ? 53 : 47) +
      (this.isLaskutusSet ? 61 : 67) +
      (this.isToimitusSet ? 71 : 73)
    );
  }
}

export async function keikkaTila_saveToDB_static(
  keikkaId,
  keikkaTilaId,
  personId,
  token,
  socket,
  varmenne = undefined
) {
  const r = await keikkaTila_saveToDB(keikkaId, keikkaTilaId, personId, token, socket);
  if (varmenne != undefined) keikka_varmenne_save_to_db(this.keikkaId, varmenne, token);
  return r;
}

export async function keikkaTila_saveSetToDB(keikkaData, token) {
  const keikkaId = keikkaData.keikkaId;
  const isLaskutusSet = keikkaData.tila.isLaskutusSet;
  const isToimitusSet = keikkaData.tila.isToimitusSet;
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      isLaskutusSet: isLaskutusSet,
      isToimitusSet: isToimitusSet,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/tila/saveSets",
    requestOptions
  ).catch((error) => {
    console.error("Error:", error);
  });
  return response.ok;
}

export async function keikkaTila_saveToDB(keikkaId, newKeikkaTilaId, personId, token, socket) {
  // save keikkaTilaId to DB
  // then emit socket event to reload keikka data

  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      keikkaId: keikkaId,
      keikkaTilaId: newKeikkaTilaId,
    }),
  };
  const response = await fetch(
    import.meta.env.VITE_SERVER_URL + "/api/keikka/tila/set",
    requestOptions
  ).catch((error) => {
    console.error("Error:", error);
  });
  if (!response.ok) return false;

  // send socket event
  const s = new socketOnSave(personId, socket, null, "keikkaTila", "save", keikkaId);
  s.keikkaData.keikkaTilaId = newKeikkaTilaId;
  s.emitSave();

  // jos tilaus poistettu: tilaId = 10, stepLogTypeId = 10
  // niin laita stepLogMessage
  if (newKeikkaTilaId == 10) {
    const sl = newStepLogMessage("Tilaus poistettu ", personId, { keikkaId: keikkaId }, 10);
    sl.keikkaId = keikkaId;
    sl.isSystemMessage = true;
    sl.requireConfirm = false;
    sl.saveToDB(socket, true);
  }

  // jos tilaus toimitettu: tilaId = 9
  // niin laita stepLogMessage  stepLogTypeId = 21: tilaus toimitettu
  if (newKeikkaTilaId == 9) {
    const sl = newStepLogMessage("Tilaus toimitettu ", personId, { keikkaId: keikkaId }, 21);
    sl.keikkaId = keikkaId;
    sl.isSystemMessage = false;
    sl.requireConfirm = false;
    sl.saveToDB(socket, true);
  }

  return true;
}

export async function keikkaTila_fetch(keikkaTilaId) {
  const tila = new tilaClass();
  const url = "/api/tila/get/" + keikkaTilaId;
  const c = cache_read(general_cacheName, url);
  if (c) return c;

  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "tilaClass:fetchTila");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  if (response.status > 399) {
    console.log(result);
    return false;
  }

  tila.setDataFromJson(result[0]);
  cache_write(general_cacheName, url, tila, 0);
  return tila;
}

let tilaList = null;
export async function keikkaTila_fetchList() {
  const url = "/api/tila/list";
  const c = cache_read(general_cacheName, url);
  if (c) return c;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cResponse = await checkResponse(response, "tilaClass:fetchTilaList");
  if (!cResponse.success) return false;
  const result = cResponse.data;
  cache_write(general_cacheName, url, result, 0);
  tilaList = result;
  return result;
}

export async function tila_getTilaType(keikkaTilaId) {
  if (tilaList == null) await keikkaTila_fetchList();
  if (tilaList == null) return "";
  const tila = tilaList.find((x) => x.keikkaTilaId == keikkaTilaId);
  if (tila == null) return "";
  return tila.iconName;
}
